import styled from "@mui/material/styles/styled";

import { Column } from "@rui/Stack";

export const Container = styled(Column)(({ theme }) => ({
  backgroundColor: "#fff",
  width: "100vw",
  minHeight: "100vh",
  color: theme.palette.shades.neutral[800],
  paddingTop: theme.spaces.xxlarge,
  paddingBottom: theme.spaces.xxlarge,
  [theme.breakpoints.up("xs")]: {
    padding: theme.spaces.xxlarge,
  },
}));

export const ContentWrapper = styled(Column)(({ theme }) => ({
  padding: theme.spaces.large,
  flex: 1,
  textAlign: "center",
  maxWidth: "500px",
}));
